import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0de297ad&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0de297ad&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de297ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0de297ad')) {
      api.createRecord('0de297ad', component.options)
    } else {
      api.reload('0de297ad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0de297ad&scoped=true", function () {
      api.rerender('0de297ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audioPackage/index.vue"
export default component.exports